import { colors } from "./colors";
import { fonts } from "./fonts";
import { transitions } from "./transitions";

export const theme = {
  fonts,
  colors,
  transitions,
};

export type Theme = typeof theme;
